import {
  Done as DoneIcon,
  Error as ErrorIcon,
  ErrorOutline as ErrorOutlineIcon,
  AutoMode as AutoModeIcon,
} from '@mui/icons-material';
import { Popper, Paper, Box, ClickAwayListener, Badge } from '@mui/material';
import { useState, useRef } from 'react';

export const FileIconBadge = ({ status, badgeContent }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);   

  const statusConfig = {
    ready: {
      icon: <DoneIcon color="white" fontSize="small" />,
      textIcon: <DoneIcon color="white" fontSize="small" />,
      message: "ready",
      color: 'success',
      bgColor: 'success.dark',
      textColor: 'common.white',
    },
    error: {
      icon: <ErrorIcon color="white" fontSize="small" />,
      textIcon: <ErrorOutlineIcon color="white" fontSize="small" />,
      message: "error",
      color: 'error',
      bgColor: 'error.dark',
      textColor: 'common.white',
    },
    processing: {
      icon: <AutoModeIcon color="white" fontSize="small" />,
      textIcon: <AutoModeIcon color="white" fontSize="small" />,
      message: "processsing",
      color: 'warning',
      bgColor: 'warning.dark',
      textColor: 'common.white',
    }
  };

  const config = statusConfig[status];

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Icon with Popper */}
      <Box
        ref={anchorRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{ display: 'flex' }}
      >
        <Badge badgeContent={badgeContent} color={config.color} showZero/>
      </Box>



        <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement="bottom"
            modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
            sx={{ zIndex: 1300, paddingTop: 1 }}
        >
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Paper
                    elevation={3}
                    sx={{
                        paddingY: 1.5,
                        paddingX: 2,
                        bgcolor: config.bgColor,
                        color: config.textColor,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontFamily: 'Manrope,sans-serif',
                    }}
                >
                    {config.icon} {config.message}
                </Paper>
                
            </ClickAwayListener>
        </Popper>
    </Box>
  );
};